import { render, staticRenderFns } from "./FaturamentoPanel.vue?vue&type=template&id=17a37edb&scoped=true"
import script from "./FaturamentoPanel.vue?vue&type=script&lang=js"
export * from "./FaturamentoPanel.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoPanel.vue?vue&type=style&index=0&id=17a37edb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a37edb",
  null
  
)

export default component.exports